<template>
  <div class="outer-page">
    <div class="footer">
      <div class="official-desc">
        <img src="@/assets/imgs/logo白@3x.png" alt="" style="width: 100px;"/>
        <p> {{ $t('footerUbpayDesc.content') }} </p>
      </div>
      <div class="menu">
        <ul class="menu-item">
          <li v-for="item in $t('footerMenu')"
              :key="item.id">
            <a
                class="first"
                @click="() => $router.push({ name: item.url.split('-')[0] })"
            >{{ item.name }}</a>
            <template>
              <p v-for="el in item.childList" :key="el.id">
                <a class="second" @click="() => goThere(el.url)">{{ el.name }}</a>
              </p>
            </template>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      companyInfo: [],
    };
  },
  methods: {
    goThere(url) {
      this.$router.push({
        name: "m" + url,
      });
    },
  }
};
</script>

<style lang="less" scoped>
.outer-page {
  width: 100%;
  .footer {
    padding: 0.667rem 0;
    line-height: 1rem;
    color: #ffffff;
    font-size: 0.53rem;
    background: #3c455e;
    .official-desc {
      padding: 0 0.82rem;
      img {
        width: 1.5rem;
        padding: 0.3rem 0;
      }
      p {
        font-size: 0.532rem;
        line-height: 1.4rem;
      }
    }
    .menu {
      padding: 1.8rem 0.82rem 0.82rem 0.82rem;
      .menu-item {
        display: flex;
        flex-wrap: wrap;
        li {
          flex: 0 0 50%;
          box-sizing: border-box;
          margin-bottom: 0.85rem;
          .first {
            display: block;
            color: #ffffff;
            font-size: 0.65rem;
            font-weight: bold;
            margin-bottom: 0.35rem;
          }
          .second {
            font-size: 0.534rem;
            line-height: 1.4rem;
            color: #d4d4d4;
            &:hover {
              color: #fff;
              border-bottom: 1px solid #fff;
            }
          }
        }
      }
    }
  }
}
</style>
